import axios from "axios"
import baseURL from "../config/api"

export const post_Leadership = (data: any, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leaderships`,
        method: "POST",
        params: { userId },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const post_LeadershipGroupMapping = (data: any[], userId: number, token: string) => {
    return axios({
        url: `${baseURL}leadershipGroupMappings/CreateBulkLeadershipGroupMapping`,
        method: "POST",
        params: { userId },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Leadership = (data: any, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leaderships?${userId}`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Leadership = (primaryKey: string, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leaderships`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey, userId }
    }).then(response => response.data);
}

export const delete_LeadershipGroupByLeadershipId = (leadershipId: string, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leadershipGroupMappings/DeleteLeadershipGroupMappingWithLeadershipId/${leadershipId},${userId}`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(response => response.data);
}

export const getleadershipGroupsMappingByGroupId = (leadershipId: number, token: string) => {
    return getFetch(`leadershipGroupMappings/GetLeadershipGroupMappingsReportByLeadershipId/${leadershipId}`, token)
}

export const getLeadershipByGroupId = (groupId: number, token: string) => {
    return getFetch("leaderships", token, { groupId })
}

export const getLeadership = (primaryKey: string, token: string) => {
    return getFetch(`leaderships/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}